import { assetTypeGetterMap } from '@/utils';

export default class Bookmark {
  constructor(obj) {
    this.bookmarkableId = obj.bookmarkableId;
    this.bookmarkableType = obj.bookmarkableType;
    this.contextId = obj.contextId;
    this.contextType = obj.contextType;
    this.deleted = obj.deleted;
    this.id = obj.id;
    this.mobileCreatedAt = obj.mobileCreatedAt;
    this.snippet = obj.snippet;
  }

  get isAttachmentBookmark() {
    return this.bookmarkableType === 'Attachment';
  }

  get isTopicBookmark() {
    return this.bookmarkableType === 'Topic';
  }

  get isFlashcardBookmark() {
    return this.bookmarkableType === 'V3Flashcard';
  }

  get getter() {
    return assetTypeGetterMap[this.bookmarkableType];
  }
}